import { useQuery } from "@apollo/react-hooks";

import { QueryLearnerArgs } from "@hubcapp/types";

import learnerDetails from "../graph-ql/learnerDetails.graphql";

const useQueryLearnerDetails = (id?: QueryLearnerArgs["id"]) =>
  useQuery(learnerDetails, {
    skip: !id,
    variables: {
      id,
    },
  });

export default useQueryLearnerDetails;
